import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { FilterModel } from '../models';

import { AppSettings } from '../helpers';

@Injectable()
export class CreationService {
    constructor(private http: HttpClient,
        private appSettings: AppSettings) { }

    filter(filterModel: FilterModel) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/creation/filter', filterModel);
    }

    upVote(contestSubmissionId: number) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/creation/up-vote', { contestSubmissionId });
    }

    downVote(contestSubmissionId: number) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/creation/down-vote', { contestSubmissionId: contestSubmissionId });
    }
}



// WEBPACK FOOTER //
// ./src/services/creation.service.ts